import noiseImage from "#assets/lander/noise.webp";

export default function LanderDesignElements() {
	return (
		<>
			<img
				src={noiseImage}
				title="Background Noise"
				alt="Background Noise"
				className="absolute top-0 left-0 w-full h-full object-cover opacity-[5%] -z-1"
			/>
			<svg
				width="1280"
				height="1280"
				viewBox="0 0 1280 1280"
				xmlns="http://www.w3.org/2000/svg"
				className="w-screen mt-[-67.5em] z-1 absolute top-0 mx-auto"
			>
				<title>Top Fade</title>
				<defs>
					<radialGradient id="top-fade" cx="50%" cy="50%" r="50%">
						<stop offset="50%" stopColor="#7a5634" />
						<stop offset="100%" stopColor="#e09d60" />
					</radialGradient>
				</defs>
				<circle cx="640" cy="640" r="640" fill="url(#top-fade)" />
			</svg>

			<svg
				width="1280"
				height="1280"
				viewBox="0 0 1280 1280"
				xmlns="http://www.w3.org/2000/svg"
				className="w-screen mb-[-67.5em] z-1 absolute bottom-0 mx-auto"
			>
				<title>Bottom Fade</title>
				<defs>
					<radialGradient id="bottom-fade" cx="50%" cy="50%" r="50%">
						<stop offset="50%" stopColor="#7a5634" />
						<stop offset="100%" stopColor="#412b34" />
					</radialGradient>
				</defs>
				<circle cx="640" cy="640" r="640" fill="url(#bottom-fade)" />
			</svg>
		</>
	);
}
